// extracted by mini-css-extract-plugin
export default {"dark":"BubbleInfos_dark__wk2pu","App":"BubbleInfos_App__0Ep0g","bubbleInfos":"BubbleInfos_bubbleInfos__qbDmq"};